import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_AES_KEY ? CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY) : undefined;

export function encrypt(data: any) {
  if (!SECRET_KEY) {
    return data;
  }
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString();
}

export function decrypt(cipherText: any) {
  if (!SECRET_KEY) {
    return cipherText;
  }
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}